import React, { FC, useState, useEffect, useMemo } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { AgentLeaderSurveyDetail, SurveyFormMode } from 'src/app/modules/Survey/types/survey-types';
import { LayoutSplashScreen } from 'src/app/layout';
import { fetchAgentLeaderSurveyItem } from '../../../network/surveyCrud';
import AgentLeaderSurveyDetailForm from './components/AgentLeaderSurveyDetailForm';

const AgentLeaderSurveyDetailPage: FC<RouteComponentProps> = ({ history }) => {
  const { id } = useParams<{ id: string }>();
  const { formMode, code } = useMemo(
    () => ({
      formMode: id ? SurveyFormMode.EDIT : SurveyFormMode.CREATE,
      code: id ? id : undefined,
    }),
    [id],
  );

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [surveyDetail, setSurveyDetail] = useState<AgentLeaderSurveyDetail>();

  const reloadData = () => {
    if (code) {
      setIsLoading(true);
      fetchAgentLeaderSurveyItem(code, dispatch)
        .then((result) => {
          setSurveyDetail(result);
        })
        .catch(() => {
          history.push(NOT_FOUND_ERROR_PAGE_PATH);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    reloadData();
    // eslint-disable-next-line
  }, [code]);

  return (
    <>
      {formMode === SurveyFormMode.CREATE && (
        <>
          <AgentLeaderSurveyDetailForm formMode={formMode} />
        </>
      )}
      {formMode === SurveyFormMode.EDIT &&
        (isLoading || !surveyDetail ? (
          <LayoutSplashScreen />
        ) : (
          <>
            <AgentLeaderSurveyDetailForm formMode={formMode} surveyDetail={surveyDetail} />
          </>
        ))}
    </>
  );
};

export default AgentLeaderSurveyDetailPage;
